// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import {api} from './api/api.js'
import Animate from 'animate.css'
import hybrid from './common/hybrid'


Vue.use(MintUI)

Vue.prototype.api = api;

Vue.config.productionTip = false

Vue.prototype.$hybrid = hybrid;

/* eslint-disable no-new */


// api.login({
//   mobile:'18674022930',
//   login_password:'waxw1130',
//   gys_id:9,
//   gys_no:'M00000008'
// }).then(res=> {
// 	new Vue({
// 	  el: '#app',
// 	  router,
// 	  components: { App },
// 	  template: '<App/>'
// 	})
// })

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


window.back = function(){
  router.back(-1)
}





// WEBPACK FOOTER //
// ./src/main.js